import './shared';

import '../styles/home_index.css';

const _dir = $('html').attr('dir');
const _isRtl = (_dir === 'rtl');

(
    ($) => {
        //     $(".block1:not('.white') .block--title").html(function () {
        //         const text = $(this).text().trim().split(" ");
        //         const first = text.shift();
        //         return (text.length > 0 ? "<span class='blue'>" + first + "</span> " : first) + text.join(" ");
        //     });
        //
        //     const offsetPadding = () => {
        //         const offset = $('.container').first().offset().left + 20;
        //         $('.offset-right').css('padding-right', offset);
        //         $('.offset-left').css('padding-left', offset);
        //     }
        //     if ($(window).width() > 767) {
        //         offsetPadding();
        //     }
        //
        //     $(window).on('resize', function () {
        //         if ($(window).width() > 767) {
        //             offsetPadding();
        //         }
        //     });
    }
)
(jQuery);

docReady(() => {
    // let navText = ['<i class="icon-arrow-left"></i>', '<i class="icon-arrow-right"></i>'];
    // if (_isRtl) {
    //     navText = ['<i class="icon-arrow-right"></i>', '<i class="icon-arrow-left"></i>'];
    // }
    //
    let targets = $('.js-lazyload');

    if (targets.length) {
        let options = {
            root: null,
            rootMargin: '0px',
            threshold: 0
        };

        let observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (!$(entry.target).hasClass('activated')) {
                        if ($(entry.target).hasClass('stats-lazyload')) {
                            $(".owl-stats").owlCarousel({
                                rtl: _isRtl,
                                margin: 20,
                                items: 4,
                                dots: true,
                                loop: true,
                                onInitialized: function (event) {
                                    const element = event.target;
                                    $(element).closest('.lazyload-block').removeClass('lazyload-block');
                                    $(entry.target).addClass('activated');

                                    $('.count').each(function () {
                                        $(this).prop('Counter', 0).animate({
                                            Counter: $(this).text()
                                        }, {
                                            duration: 4000,
                                            easing: 'swing',
                                            step: function (now) {
                                                $(this).text(Math.ceil(now));
                                            }
                                        });
                                    });

                                    $(element).find('.owl-dot').each(function (index, element) {
                                        if (element.tagName.toLowerCase() === 'button') {
                                            $(element).attr('aria-label', 'Slide #' + ++index);
                                        }
                                    });
                                },
                                responsive: {
                                    0: {
                                        items: 1,
                                    },
                                    576: {
                                        items: 2,
                                    },
                                    768: {
                                        items: 3,
                                    },
                                    1200: {
                                        items: 4,
                                    }
                                }
                            });
                        } else if ($(entry.target).hasClass('network-lazyload')) {
                            $(".owl-network").owlCarousel({
                                rtl: _isRtl,
                                items: 1,
                                dots: true,
                                loop: true,
                                autoplay: true,
                                autoplayTimeout: 5000,
                                animateIn: 'fadeIn',
                                animateOut: 'fadeOut',
                                onInitialized: function (event) {
                                    const element = event.target;
                                    $(element).closest('.lazyload-block').removeClass('lazyload-block');
                                    $(entry.target).addClass('activated');

                                    const items = $(element).find('.owl-item:not(.cloned) .item6');

                                    $(element).find('.owl-dot').each(function (index, element) {
                                        const item = items.eq(index);
                                        const dot = $(`<div class='dot-image'><img src="${item.data('image')}" alt="${item.data('title')}"><div class="title">${item.data('title')}</div></div>`)
                                        $(element).append(dot);

                                        if (element.tagName.toLowerCase() === 'button') {
                                            $(element).attr('aria-label', 'Slide #' + ++index);
                                        }
                                    });
                                }
                            });
                        } else if ($(entry.target).hasClass('projects-lazyload')) {
                            $(".owl-projects").owlCarousel({
                                rtl: _isRtl,
                                margin: 20,
                                items: 3,
                                dots: true,
                                loop: true,
                                onInitialized: function (event) {
                                    const element = event.target;
                                    $(element).closest('.lazyload-block').removeClass('lazyload-block');
                                    $(entry.target).addClass('activated');
                                },
                                responsive: {
                                    0: {
                                        items: 1,
                                    },
                                    768: {
                                        items: 2,
                                    },
                                    1200: {
                                        items: 3,
                                    }
                                }
                            });
                        } else if ($(entry.target).hasClass('js-particles')) {
                            const _url = application.particles_url;
                            const particlesScript = document.createElement('script');
                            particlesScript.setAttribute('src', _url);
                            particlesScript.setAttribute('async', 'async');
                            document.body.appendChild(particlesScript);

                            $(entry.target).addClass('activated');
                        }
                    }
                }
            });
        }, options);

        targets.each(target => {
            observer.observe(targets[target]);
        });
    }
});